export default "__VITE_ASSET__2tZcnlZ2__"